export default "__VITE_ASSET__d447370e__"